<template>
  <div class="relative min-h-screen w-full" v-on:mouseleave="mouseleave">
    <!-- <div class="fixed top-4 left-4">
      {{ currentStepNumber }}
    </div> -->
    <div
      class="absolute inset-0 bg-gray-100 hidden sm:flex sm:flex-col md:hidden justify-center items-center z-50"
    >
      <img
        class="mx-auto w-40 h-40 p-4 bg-red-600 rounded-full"
        :src="getUrl('wp-content/uploads/2021/09/rotate.gif')"
      />
      <p class="mt-4">Per favore ruota il dispositivo per procedere, grazie.</p>
    </div>
    <div class="md:h-screen pb-14" v-show="!showLoader">
      <div class="grid grid-cols-12 h-full w-full">
        <div
          id="main-box"
          class="flex flex-col px-3 md:px-6 pt-8 pb-20 w-full text-center overflow-y-auto h-full relative justify-start col-span-12 md:col-span-10"
          :class="[isRecipesStep ? '' : '']"
        >
          <div ref="main-template" id="position-pix" class="h-1 w-1 opacity-0">
            &nbsp;
          </div>
          <ul class="step-disc-container">
            <li
              class="step-disc"
              v-for="n in 11"
              v-if="n > 0"
              :key="n"
              :class="[
                currentStepNumber > n ? 'step-done' : '',
                currentStepNumber == n ? 'step-active' : '',
              ]"
            >
              {{ n }}
            </li>
          </ul>
          <keep-alive>
            <component
              class="mx-auto w-full"
              :class="[isRecipesStep ? 'max-w-6xl' : 'max-w-4xl']"
              ref="currentStep"
              :is="currentStep"
              @updateAsyncState="updateAsyncState"
              :wizard-data="form"
              :dog-data="dog"
              :list-data="lists"
              @disableActionButton="enableActionButton"
              @prices="sendPrices"
              @barAsyncState="sendBarAsyncState"
            ></component>
          </keep-alive>

          <div class="mx-auto w-full max-w-4xl pt-6" v-if="currentStepNumber == 1">
            <label class="flex justify-center">
              <input
                type="checkbox"
                id="checked"
                class="privacy-check"
                v-model="privacy"
              />
              <div class="ml-2 text-sm leading-snug">
                Dichiaro di essere maggiorenne e di aver letto ed accettato la
                <a
                  class="text-red-600 underline"
                  :href="getUrl('privacy-policy/')"
                  target="_blank"
                  >privacy policy</a
                >
                e le
                <a
                  class="text-red-600 underline"
                  :href="getUrl('termini-e-condizioni/')"
                  target="_blank"
                  >condizioni generali di servizio</a
                >
              </div>
            </label>
          </div>

          <!-- Actions -->
          <div class="buttons mx-auto w-full max-w-xl mt-12 flex flex-col">
            <button
              :id="'v2_next-btn-step' + currentStepNumber"
              @click="nextButtonAction"
              class="btn-main"
              :class="[!privacy || disableActionButton ? 'disabled' : '']"
              :disabled="!privacy || disableActionButton"
            >
              <div class="flex justify-center gap-4" v-if="disableActionButton">
                <svg
                  class="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    class="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    stroke-width="4"
                  ></circle>
                  <path
                    class="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
              </div>
              <div v-else>
                {{ nextStepButtonMessage }}
              </div>
            </button>
            <button
              :id="'v2_back-btn-step' + currentStepNumber"
              @click="goBack"
              v-if="currentStepNumber > 1"
              class="px-4 py-2 text-red-600 underline focus:ring-0 focus:outline-none mt-6 inline-block mx-auto"
            >
              Torna indietro
            </button>
          </div>
        </div>
        <div
          class="col-span-12 md:col-span-2 items-center justify-center illustration-container"
        >
          <StepIllustration
            :desktopIllustration="getImageUrl(currentDesktopIllustration)"
            :mobileIllustration="getImageUrl(currentMobileIllustration)"
            :currentStep="currentStepNumber"
          ></StepIllustration>
        </div>
      </div>
    </div>

    <div class="hidden absolute bg-gray-100 h-1.5 left-0 progress-bar top-0 w-full z-50">
      <div class="progress" :style="`width: ${progress}%;`">&nbsp;</div>
    </div>

    <div class="loading-wrapper end-message" v-show="showLoader">
      <div class="loader mx-auto max-w-2xl">
        <img
          class="mx-auto rounded-full h-auto w-72"
          :src="getUrl('wp-content/uploads/2021/09/nonna_ragu.gif')"
          alt=""
        />
        <h1 class="title mt-8" v-if="rbAction == 'rb_add_to_cart'">
          Stiamo preparando la pappa su misura per
          <span v-if="form.numberOfDogs > 1">
            i tuoi {{ form.numberOfDogs }} amici a quattro zampe
          </span>
          <span v-else>
            {{ dog.sex == 1 ? "il tuo" : "la tua" }} {{ dog.name | capitalize }}
          </span>
        </h1>
        <h1 v-else-if="rbAction == 'rb_send_email_user_type'">
          Stiamo registrando il tuo contatto, verrai ricontattato il prima possibile per
          una proposta su misura!
        </h1>
        <h1 v-else-if="rbAction == 'rb_send_email_dog_not_healthy'">
          Stiamo verificando le disponibilità dei nostri nutrizionisti, verrai
          ricontattato il prima possibile con una proposta di appuntamento!
        </h1>
        <h1 v-else></h1>
      </div>
    </div>

    <StatusBar
      :asyncState="barAsyncState"
      :prices="currentStepNumber <= 7 ? [] : prices"
    ></StatusBar>
  </div>
</template>

<script>
import Form01UserInfo from "./Form01UserInfo";
import Form02DogInfo01 from "./Form02DogInfo01";
import Form03DogInfo02 from "./Form03DogInfo02";
import Form04DogInfo03 from "./Form04DogInfo03";
import Form05DogInfo04 from "./Form05DogInfo04";
import Form06FoodInfo01 from "./Form06FoodInfo01";
import Form07FoodInfo02 from "./Form07FoodInfo02";
import Form08FoodInfo03 from "./Form08FoodInfo03";
import Form09FoodInfo04 from "./Form09FoodInfo04";
import Form10FoodInfo05 from "./Form10FoodInfo05";
import Form11UserInfo02 from "./Form11UserInfo02";

import snakecaseKeys from "snakecase-keys";
import camelcaseKeys from "camelcase-keys";

import axios from "axios";
import StepIllustration from "./StepIllustration";
import StatusBar from "./StatusBar";

export default {
  name: "FormWizard",
  components: {
    StatusBar,
    StepIllustration,
    Form01UserInfo,
    Form02DogInfo01,
    Form03DogInfo02,
    Form04DogInfo03,
    Form05DogInfo04,
    Form06FoodInfo01,
    Form07FoodInfo02,
    Form08FoodInfo03,
    Form09FoodInfo04,
    Form10FoodInfo05,
    Form11UserInfo02,
  },
  data() {
    return {
      pluginNumber: "2",
      couponAttempts: 0,
      debug: process.env.NODE_ENV == "development",
      privacy: false,
      // illustration: "",
      desktopIllustration: "",
      mobileIllustration: "",
      currentStepNumber: 1,
      asyncState: null,
      barAsyncState: null,
      sendinblueApiKey: null,
      prices: [],
      disableActionButton: false,
      rbAction: "",
      helpOpen: false,
      canGoToCheckout: false,
      steps: [
        "Form01UserInfo",
        "Form02DogInfo01",
        "Form03DogInfo02",
        "Form04DogInfo03",
        "Form05DogInfo04",
        "Form06FoodInfo01",
        "Form07FoodInfo02",
        "Form08FoodInfo03",
        "Form09FoodInfo04",
        "Form10FoodInfo05",
        "Form11UserInfo02",
      ],
      illustrations: {
        desktop: [
          "questionario_02.jpg",
          "questionario_03.jpg",
          "questionario_04.jpg",
          "questionario_05.jpg",
          "questionario_05.jpg",
          "questionario_07.jpg",
          "questionario_08.jpg",
          "questionario_09.jpg",
          "questionario_10.jpg",
          "questionario_11.jpg",
          "questionario_11.jpg",
        ],
        mobile: [
          "questionario_02_mobile.jpg",
          "questionario_03_mobile.jpg",
          "questionario_04_mobile.jpg",
          "questionario_05_mobile.jpg",
          "questionario_05_mobile.jpg",
          "questionario_07_mobile.jpg",
          "questionario_08_mobile.jpg",
          "questionario_09_mobile.jpg",
          "questionario_10_mobile.jpg",
          "questionario_11_mobile.jpg",
          "questionario_11_mobile.jpg",
        ],
      },
      form: {
        userType: null,
        name: null,
        email: null,
        postcode: null,
        isRemoteArea: 0,
        phoneNumber: null,
        numberOfDogs: null,
        indexDog: 0,
        dogs: [],
        sameDiet: 1,
        foodPreparationMethodId: null,
        subscriptionPeriodInDays: 28,
        knownThrough: null,
        couponCode: "",
        couponDiscount: null,
        couponCodeDefault: "",
        couponDiscountDefault: null,
      },
      dog: {},
      lists: {
        breeds: [],
        ingredients: [],
        foodPreparationMethods: [],
        recipes: [],
        extraIngredients: [],
      },
    };
  },
  watch: {
    "form.numberOfDogs": function (value) {
      if (value && this.currentStepNumber == 2) {
        this.form.dogs = [];
        for (let i = 0; i < value; i++) {
          this.$set(this.form.dogs, i, this.initialState());
        }
      }
    },
    "form.indexDog": function () {
      Object.assign(this.dog, this.form.dogs[this.form.indexDog]);
    },
  },
  computed: {
    isIntro() {
      return this.currentStepNumber === 1;
    },
    isLastStep() {
      return this.currentStepNumber === this.length && !this.goNextDogWithDifferentDiet;
    },
    isCouponStep() {
      return this.currentStepNumber === 11;
    },
    wizardInProgress() {
      return this.currentStepNumber <= this.length;
    },
    showLoader() {
      return this.asyncState === "pending";
    },
    length() {
      return this.steps.length;
    },
    currentStep() {
      return this.steps[this.currentStepNumber - 1];
    },
    progress() {
      return (this.currentStepNumber / this.length) * 100;
    },
    /*
      currentIllustration() {
        return this.illustrations.desktop[this.currentStepNumber - 1];
      },
      */
    currentDesktopIllustration() {
      return this.illustrations.desktop[this.currentStepNumber - 1];
    },
    currentMobileIllustration() {
      return this.illustrations.mobile[this.currentStepNumber - 1];
    },
    nextStepButtonMessage() {
      return this.isLastStep
        ? "Vai al Checkout"
        : this.goNextDogWithSameDiet || this.goNextDogWithDifferentDiet
        ? "Vai al prossimo peloso"
        : "Prossimo step";
    },
    dogsWithSameDiet() {
      return this.form.numberOfDogs >= 2 && this.form.sameDiet == 1;
    },
    goNextDogWithSameDiet() {
      return (
        this.dogsWithSameDiet &&
        this.currentStepNumber == 5 &&
        this.form.indexDog + 1 < this.form.numberOfDogs
      );
    },
    goBackDogWithSameDiet() {
      return (
        (this.dogsWithSameDiet || this.dogsWithDifferentDiet) &&
        this.currentStepNumber == 2 &&
        this.form.indexDog + 1 <= this.form.numberOfDogs &&
        this.form.indexDog > 0
      );
    },
    dogsWithDifferentDiet() {
      return this.form.numberOfDogs >= 2 && this.form.sameDiet == 0;
    },
    goNextDogWithDifferentDiet() {
      return (
        this.dogsWithDifferentDiet &&
        this.currentStepNumber == 10 &&
        this.form.indexDog + 1 < this.form.numberOfDogs
      );
    },
    isRecipesStep() {
      return this.currentStepNumber == 7;
    },
  },
  methods: {
    scrollFunnelToTop() {
      // To scroll to top needs to use $nextTick.
      // DOM is not updated yet.
      this.$nextTick(function () {
        // DOM is now updated.
        // `this` is bound to the current instance.
        this.$refs["main-template"].scrollIntoView({
          behavior: "smooth",
          block: "end",
          inline: "nearest",
        });
      });
    },
    getUrl(value) {
      return this.$hostname + "/" + value;
    },
    getImageUrl(value) {
      return this.getUrl("wp-content/uploads/2022/12/" + value);
    },
    mouseleave() {
      // Opens video popup when mouse leave
      var stepWithVideoPopup = [6, 9, 10];
      if (stepWithVideoPopup.includes(this.currentStepNumber)) {
        this.$refs.currentStep.openModal();
      }
    },
    sendPrices(value) {
      this.prices = value;
    },
    sendBarAsyncState(value) {
      this.barAsyncState = value;
    },
    enableActionButton(value) {
      this.disableActionButton = value;
    },
    updateAsyncState(state) {
      this.asyncState = state;
    },
    updateDogsWithSameDiet(dog) {
      if (this.dogsWithSameDiet) {
        if (
          "isFullMeal" in dog ||
          "recipeId" in dog ||
          "isDoubleTaste" in dog ||
          "oilSlug" in dog ||
          "extraIngredientIds" in dog ||
          "seasonalVegetables" in dog ||
          "isDuplex" in dog
        ) {
          for (let i = 0; i < this.form.numberOfDogs; i++) {
            for (const key in dog) {
              this.$set(this.form.dogs[i], key, dog[key]);
            }
          }
        }
      }
    },
    submitOrder() {
      this.updateAsyncState("pending");
      const url = this.$hostname + "/checkout";
      const config = {
        headers: { "Content-Type": "application/json" },
      };
      let data = JSON.stringify(
        snakecaseKeys({ form: this.form, rbAction: this.rbAction })
      );
      this.saveToLocalStorage();

      axios
        .post(url, data, config)
        .then(function () {
          window.location = "/" + "checkout";
        })
        .catch(function (error) {
          if (this.debug) console.log(error);
        });
    },
    initialState() {
      return {
        name: null,
        dogId: null,
        breedId: null,
        breedIdFather: null,
        breedIdMother: null,
        sex: null,
        neutering: null,
        hasBirthDate: null,
        birthDate: null,
        months: null,
        adult: null,
        healthy: null,
        disease: "",
        weight: null,
        activityLevel: null,
        bodyConditionScoreSystem: null,
        recipeId: null,
        extraIngredientIds: [],
        allergyIds: [],
        otherFoodAllergies: null,
        oilSlug: null,
        isFullMeal: 1,
        isDoubleTaste: null,
        seasonalVegetables: null,
        isDuplex: 0,
      };
    },
    nextButtonAction() {
      this.$refs.currentStep
        .submit()
        .then((stepData) => {
          var dogCopy = [];
          Object.assign(this.dog, stepData.dog);
          Object.assign(this.form, stepData.form);
          dogCopy = Object.assign({}, this.dog);
          this.$set(this.form.dogs, this.form.indexDog, dogCopy);
          this.rbAction = "";

          if ("dog" in stepData) {
            this.updateDogsWithSameDiet(stepData.dog);
          }

          if (!this.isLastStep) {
            this.sendaDataToGoogleTagManager("funnelStepCompleted");
          }
          if (this.currentStepNumber == 1) {
            this.sendaDataToGoogleTagManager("funnelLead");
          }

          if (this.form.userType != 1 && this.currentStepNumber == 1) {
            this.rbAction = "rb_send_email_user_type";
            this.sendEmail();
          } else if (
            this.currentStepNumber == 5 &&
            this.form.phoneNumber &&
            this.dog.healthy == 0 &&
            this.dog.disease != ""
          ) {
            this.rbAction = "rb_send_email_dog_not_healthy";
            this.sendEmail();
          } else if (this.isLastStep) {
            // if (this.isCouponStep && this.couponAttempts < 2 && !this.canGoToCheckout) {
            this.fetchCoupon();
            // } else {
            // this.canGoToCheckout = true;
            // }
            if (this.canGoToCheckout) {
              this.goToCheckout();
            }
          } else if (this.goNextDogWithSameDiet || this.goNextDogWithDifferentDiet) {
            this.goNextDog();
          } else {
            if (this.currentStepNumber == 1) {
              this.sendDataToSendinBlue();
              this.sendDataToHubspot();
            }
            this.goNext();
          }
        })
        .catch((error) => {
          if (this.debug) console.log(error);
        });
      this.scrollFunnelToTop();
    },
    goToCheckout() {
      this.sendDataToSendinBlue();
      this.sendaDataToGoogleTagManager("funnelToCheckout");

      this.rbAction = "rb_add_to_cart";
      this.submitOrder();
    },
    saveToLocalStorage() {
      localStorage.setItem("RBStoredData", JSON.stringify(this.form));
      localStorage.setItem("RBCurrentStepNumber", JSON.stringify(this.currentStepNumber));
      localStorage.setItem("RBFormWizard", JSON.stringify(this.pluginNumber));
    },
    removeFromLocalStorage() {
      localStorage.removeItem("RBStoredData");
      localStorage.removeItem("RBCurrentStepNumber");
      localStorage.removeItem("RBFormWizard");
    },
    fetchCoupon() {
      if (this.form.couponCode === null) {
        this.couponAttempts = 0;
        this.canGoToCheckout = true;
      } else {
        this.$refs.currentStep.loaderAsyncState("pending");

        let data = new FormData();
        data.append("action", "coupon_exists");
        data.append("coupon", this.form.couponCode);

        axios
          .post(rb_sbt.ajaxurl, data)
          .then((response) => {
            let res = response.data;
            if (res.success == false) {
              this.couponAttempts++;
              if (this.couponAttempts == 1) {
                this.$refs.currentStep.setErrorMessage(
                  "Ops! Prova a scrivere di nuovo il suo codice."
                );
                this.canGoToCheckout = false;
              } else if (this.couponAttempts == 2) {
                this.$refs.currentStep.setErrorMessage(
                  "Questo codice non risulta disponibile, non ti preoccupare clicca su prosegui e avrai un sconto sul tuo acquisto."
                );
                this.canGoToCheckout = false;
              } else {
                this.canGoToCheckout = true;
              }
              this.form.couponDiscount = null;
              this.form.couponDiscount = null;
            } else {
              this.form.couponDiscount = res.data.discount;
              this.canGoToCheckout = true;
            }
            this.$refs.currentStep.loaderAsyncState("success");

            // If coupon exists, go to checkout.
            if (this.canGoToCheckout) {
              this.goToCheckout();
            }
          })
          .catch((error) => {
            if (this.debug) console.log(error);
            this.$refs.currentStep.setErrorMessage("Ops! Qualcosa è andato storto!");
            this.$refs.currentStep.loaderAsyncState("success");
          });
      }
    },
    sendEmail() {
      this.updateAsyncState("pending");
      this.removeFromLocalStorage();

      const url = this.$restAPIurlRB + "send-email";
      const config = {
        headers: { "Content-Type": "application/json" },
      };
      let data = JSON.stringify(
        snakecaseKeys({ form: this.form, rbAction: this.rbAction })
      );

      axios
        .post(url, data, config)
        .then((response) => {
          if (response.data.sent == true) {
            window.location = "/" + "thank-you";
          } else {
            window.location = "/" + "oops";
          }
          // this.rbAction = "";
        })
        .catch((error) => {
          if (this.debug) console.log(error);
        });
    },
    goBack() {
      if (this.isLastStep) {
        this.couponAttempts = 0;
      }
      if (this.disableActionButton) this.disableActionButton = false;
      this.saveToLocalStorage();
      if (this.goBackDogWithSameDiet) {
        this.goBackDog();
      } else {
        this.currentStepNumber--;
      }
      this.scrollFunnelToTop();
    },
    goBackDog() {
      this.currentStepNumber = 10;
      if (this.dogsWithSameDiet) {
        this.currentStepNumber = 5;
      }
      this.form.indexDog--;
    },
    goNext() {
      this.saveToLocalStorage();
      this.currentStepNumber++;
    },
    goNextDog() {
      this.currentStepNumber = 1;
      this.form.indexDog++;
      this.goNext();
    },
    sendDataToSendinBlue() {
      const url = this.$restAPIurlRB + "sb";
      const config = {
        headers: { "Content-Type": "application/json" },
      };
      const today = new Date();
      const urlParams = new URLSearchParams(window.location.search);

      const formSendingBlue = Object.assign({}, this.form);
      formSendingBlue.funnelID = this.pluginNumber;
      formSendingBlue.funnelStartDate =
        ("00" + today.getUTCDate()).slice(-2) +
        "-" +
        ("00" + (today.getUTCMonth() + 1)).slice(-2) +
        "-" +
        today.getUTCFullYear(); //gg-mm-aaaa;
      formSendingBlue.status = "Attivo";
      formSendingBlue.utmSource = urlParams.get("utm_source");
      formSendingBlue.utmMedium = urlParams.get("utm_medium");
      formSendingBlue.utmCampaign = urlParams.get("utm_campaign");
      formSendingBlue.utmContent = urlParams.get("utm_content");
      formSendingBlue.utmTerm = urlParams.get("utm_term");

      let data = JSON.stringify(
        snakecaseKeys({
          form: formSendingBlue,
          rbAction: "rb_sb",
          currentStepNumber: this.currentStepNumber,
          nonce: window.WP_API_Settings.nonce,
        })
      );

      axios
        .post(url, data, config)
        .then((response) => {
          // this.rbAction = "";
          if (this.debug) console.log(response);
        })
        .catch((error) => {
          if (this.debug) console.log(error);
        });
    },
    sendDataToHubspot() {
      const url = this.$restAPIurlRB + "hs";
      const config = {
        headers: { "Content-Type": "application/json" },
      };
      const formData = Object.assign({}, this.form);

      let data = JSON.stringify(
        snakecaseKeys({
          form: formData,
          rbAction: "rb_hs",
          nonce: window.WP_API_Settings.nonce,
        })
      );

      axios
        .post(url, data, config)
        .then((response) => {
          if (this.debug) console.log(response);
        })
        .catch((error) => {
          if (this.debug) console.log(error);
        });
    },
    sendaDataToGoogleTagManager(eventValue) {
      let data = {
        event: eventValue,
        funnel: {
          stepID: this.pluginNumber,
          stepCount: 11,
        },
      };
      if (eventValue == "funnelStepCompleted" || eventValue == "funnelLead") {
        data.funnel.currentStep = this.currentStepNumber.toString();
      }
      this.$nextTick(function () {
        window.dataLayer.push(data);
      });
    },
    async fetchLists() {
      // Must be with promise, otherwise some lists will remain empty
      this.enableActionButton(true);
      // fetch uset types, breeds, ingredients, foodPreparationMethods, double tast, extraIngredients
      const [
        breeds,
        ingredients,
        foodPreparationMethods,
        recipes,
        extraIngredients,
      ] = await Promise.all([
        fetch(this.$restAPIurlRB + "breeds"),
        fetch(this.$restAPIurlWP + "ingredient?_fields=id,name&per_page=100"),
        fetch(
          this.$restAPIurlWP + "food-preparation-method?_fields=id,name&per_page=100"
        ),
        fetch(
          this.$restAPIurlWP +
            "recipe?_fields=id,title,food-preparation-method,ingredient,toolset-meta.recipes-details.recipe-main-ingredient-icon,toolset-meta.ingredient"
        ),
        fetch(this.$restAPIurlRB + "extra-ingredients"),
      ]);

      this.lists.breeds = await breeds.json();
      this.lists.ingredients = await ingredients.json();
      this.lists.foodPreparationMethods = await foodPreparationMethods.json();
      this.lists.recipes = camelcaseKeys(await recipes.json(), {
        deep: true,
      });
      this.lists.extraIngredients = camelcaseKeys(await extraIngredients.json(), {
        deep: true,
      });
      this.lists.howDidYouKnowUs = [
        {
          id: 0,
          name: "Tramite Internet (Facebook, Instagram, ...)",
        },
        {
          id: 1,
          name: "Tramite un Professionista (Allevatore, Veterinario, ...)",
        },
        { id: 2, name: "Altro" },
      ];

      // Fetch coupon code.
      let data = new FormData();
      data.append("action", "coupon_default");

      axios
        .post(rb_sbt.ajaxurl, data)
        .then((response) => {
          let res = response.data;
          if (res.success == true) {
            this.form.couponCodeDefault = res.data.couponCode;
            this.form.couponDiscountDefault = res.data.discount;
          }
        })
        .catch((error) => {
          if (this.debug) console.log(error);
        });

      this.enableActionButton(false);
    },
  },
  async created() {
    this.updateAsyncState("");

    // Must be async/await, otherwise some lists will remain empty
    await this.fetchLists();

    // Then get data from local storage
    var RBLastclear = localStorage.getItem("RBLastclear"),
      time_now = new Date().getTime();

    // .getTime() returns milliseconds so 1000 * 60 * 60 * 24 = 24 h
    if (time_now - RBLastclear > 1000 * 60 * 60 * 24 * 7) {
      this.removeFromLocalStorage();
      // localStorage.clear();
      localStorage.setItem("RBLastclear", time_now);
    }

    var RBStoredData = JSON.parse(localStorage.getItem("RBStoredData"));
    var RBCurrentStepNumber = JSON.parse(localStorage.getItem("RBCurrentStepNumber"));
    var RBFormWizard = parseInt(JSON.parse(localStorage.getItem("RBFormWizard")));

    if (RBStoredData && RBCurrentStepNumber > 1 && RBFormWizard) {
      if (RBFormWizard == parseInt(this.pluginNumber)) {
        this.privacy = true;
        Object.assign(this.dog, RBStoredData.dogs[RBStoredData.indexDog]);
        Object.assign(this.form, RBStoredData);
        this.currentStepNumber = RBCurrentStepNumber;
        if (RBCurrentStepNumber > this.length) {
          this.currentStepNumber = this.length;
        }
      } else {
        this.dog = this.initialState();
      }
    } else {
      this.dog = this.initialState();
    }

    if (this.currentStepNumber == 1) {
      this.sendaDataToGoogleTagManager("funnelStart");
    }
  },
};
</script>

<style>
@font-face {
  font-family: "GoodMood";
  font-display: swap;
  src: url("../assets/font/GoodMoodRevised.otf") format("opentype");
}

#rb-app2 div:empty {
  @apply hidden;
}
#rb-app2 .loading-wrapper {
  @apply bg-white flex items-center justify-center text-center z-30;
}
#rb-app2 .end-message {
  @apply h-screen;
}
#rb-app2 .illustration-container {
  background-image: url("../assets/images/sfondo_pappe.jpg");
  background-size: cover;
  background-position: center;
}
#rb-app2 .progress {
  @apply absolute bg-red-600 h-full left-0 top-0 transition-all ease-in-out duration-200;
}
#rb-app2 .title {
  @apply text-4xl text-red-600;
}
#rb-app2 .subtitle {
  @apply text-xl md:leading-tight leading-7;
}
#rb-app2 .form-group {
  @apply mt-5;
}
#rb-app2 .form-label {
  @apply text-lg font-semibold text-gray-800;
}
#rb-app2 .important-label {
  @apply block text-4xl leading-7 text-red-600 font-normal rb-subtitle-font;
}
#rb-app2 .error {
  @apply mt-2 text-sm text-red-800;
}
#rb-app2 .form-control {
  @apply mt-8 shadow-sm border-solid border-0 border-b-2 border-gray-400 focus:border-gray-800 focus:bg-gray-100 block w-full sm:text-2xl focus:ring-0 focus:outline-none placeholder-gray-300 text-center appearance-none py-1 px-2;
}
#rb-app2 .privacy-check {
  @apply appearance-none checked:border-transparent checked:bg-red-600 focus:ring-2 focus:ring-red-300 focus:outline-none !important;
}
#rb-app2 input::-webkit-outer-spin-button,
#rb-app2 input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
#rb-app2 [type="number"].form-control {
  -moz-appearance: textfield;
}
#rb-app2 textarea.form-control {
  @apply h-16;
}
#rb-app2 .switch-container {
  @apply mt-2.5 flex rounded-full border-solid border-3 border-red-600 overflow-hidden md:w-1/2 mx-auto w-11/12;
}
#rb-app2 .switch-container.big {
  @apply md:w-10/12 mx-auto w-11/12;
}
#rb-app2 .switch-container.small {
  @apply mt-2.5 mx-auto max-w-sm w-full;
}
#rb-app2 .switch-empty {
  @apply divide-x-3 divide-red-600;
}
#rb-app2 .switch-empty .switch-option {
  @apply border-solid;
}
#rb-app2 .switch-option {
  @apply p-2 text-center w-1/2 text-lg flex items-center justify-center leading-tight font-semibold cursor-pointer transition-colors duration-200 ease-in-out;
}
#rb-app2 .small .switch-option {
  @apply p-2 text-center w-1/2 text-sm flex items-center justify-center leading-tight font-semibold cursor-pointer transition-colors duration-200 ease-in-out;
}
#rb-app2 .active-option {
  @apply bg-red-600 text-white;
}
#rb-app2 .inactive-option {
  @apply bg-white text-red-600;
}
#rb-app2 .big-active-option,
#rb-app2 .big-inactive-option {
  @apply cursor-pointer border-gray-300 transition-colors duration-200 ease-in-out;
}
#rb-app2 .big-active-option {
  @apply border-red-600;
}
#rb-app2 .option-btn {
  @apply inline-block mx-auto px-14 text-4xl mt-4 border-2 border-solid leading-7 rounded-3xl transition-colors duration-200 ease-in-out;
}
#rb-app2 .big-active-option .option-btn {
  @apply bg-red-600 text-white border-red-600;
}
#rb-app2 .big-inactive-option .option-btn {
  @apply bg-white text-gray-400 border-gray-400;
}
#rb-app2 .additional-info {
  @apply text-base text-gray-500 mt-3 leading-5;
}
#rb-app2 .btn-main {
  @apply w-full focus:ring-0 focus:outline-none transition-colors max-w-xs mx-auto text-center bg-red-600 text-white rb-subtitle-font text-3xl px-4 py-2 rounded-3xl;
}
#rb-app2 .btn-main.disabled {
  @apply cursor-not-allowed border-gray-400 text-gray-500 hover:border-gray-400 hover:bg-gray-50 hover:text-gray-500 bg-gray-50 !important;
}
#rb-app2 .options-container {
  @apply flex flex-wrap justify-center space-x-2;
}
#rb-app2 .option-tag {
  @apply border-solid border-3 rounded-xl px-4 py-1 text-lg uppercase font-semibold mt-2 cursor-pointer transition-colors;
}
#rb-app2 .option-tag.unchecked {
  @apply border-gray-400 text-gray-400;
}
#rb-app2 .option-tag.checked {
  @apply border-red-600 text-red-600;
}
#rb-app2 .option-tag span {
  @apply whitespace-nowrap;
}
#rb-app2 .option-radio {
  @apply flex flex-col border-gray-300 p-4 rounded-xl border-solid border-3 items-start transition-colors cursor-pointer;
}
#rb-app2 .option-radio.option-icon {
  @apply flex-row justify-between items-center px-3 py-2;
}
#rb-app2 .option-radio.checked {
  @apply border-red-600 text-red-600;
}
#rb-app2 .option-label {
  @apply font-semibold transition-colors;
}
#rb-app2 .option-detail {
  @apply text-gray-400 text-sm;
}
#rb-app2 .rb_recipe-title {
  min-height: 2.5em;
  padding-bottom: 10px;
  @apply mx-auto font-semibold text-red-600;
}

#rb-app2 .rb_recipe-description {
  line-height: 1.2em;
  max-width: 85%;
  min-height: 4.8em;
  @apply mx-auto;
}

#rb-app2 .step-number {
  @apply rounded-full bg-red-600 text-white w-24 h-24 flex items-center justify-center text-7xl mx-auto mb-4 rb-subtitle-font;
}

#rb-app2 .step-disc-container {
  @apply flex justify-between list-none transform max-w-4xl mx-auto w-full p-0 rb-subtitle-font -translate-y-4;
}
#rb-app2 .step-disc {
  @apply text-2xl md:text-4xl md:leading-7 leading-4 rounded-full h-5 w-5 md:h-8 md:w-8 block border-solid border-2 border-gray-400 text-gray-400;
}

#rb-app2 .step-done {
  @apply border-red-600 text-red-600;
}

#rb-app2 .step-active {
  @apply border-red-600 text-white bg-red-600;
}

#rb-app2 .vs__dropdown-toggle {
  border: none;
}
</style>
